
import { mapGetters } from 'vuex'

import { getRelatedBlogPostPreviews } from '~/graphql/queries.graphql'

export default {
  props: {
    page: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      blogs: [],
      products: [],
      productPages: 0,
      isLoading: false,
      options: {
        grabCursor: true,
        slidesPerView: 'auto',

        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },

        breakpoints: {
          0: {
            spaceBetween: 16,
          },

          768: {
            spaceBetween: 32,
          },
        },
      },
    }
  },

  async fetch() {
    this.isLoading = true

    const { data } = await this.$axios.post('/product-search', {
      page: parseInt(this.$route.query?.seite) || 1,
      category: this.currentCategoryId,
      dimension: this.$route.query?.groesse,
      sort: sortBy[this.$route.query?.sortierung || 'relevanz'],
    })

    this.products = data.entries
    this.productPages = Math.ceil(data.total / 16)

    this.isLoading = false

    const blogs = await this.$graphql.cms.request(getRelatedBlogPostPreviews, {
      category: this.currentCategoryId,
      limit: 2,
    })
    this.blogs = blogs.entries.data
  },

  computed: {
    ...mapGetters('global', ['shopNavigation']),

    currentCategoryId() {
      if (this.page.entry.breadcrumbs.length === 2) {
        return this.shopNavigation.find((n) => n.page.url === this.$route.path)
          .page.category_id
      }

      if (this.page.entry.breadcrumbs.length === 3) {
        return this.shopNavigation
          .map((n) => n.children)
          .flat()
          .find((n) => n.page.url === this.$route.path).page.category_id
      }

      return this.shopNavigation
        .map((n) => n.children)
        .flat()
        .map((n) => n.children)
        .flat()
        .find((n) => n.page.url === this.$route.path).page.category_id
    },

    heading() {
      const breadcrumbs = this.page.entry.breadcrumbs

      return breadcrumbs[breadcrumbs.length - 1].title
    },
  },

  watch: {
    '$route.query'({ seite, groesse, sortierung }, previous) {
      this.isLoading = true

      const size = groesse || ''
      const sort = sortierung || 'relevanz'

      let page = parseInt(seite) || 1
      if (groesse !== previous.groesse) {
        page = 1

        this.$router.push({
          path: this.$route.path,
          query: { ...this.$route.query, seite: page },
        })
      }

      this.$axios
        .post('/product-search', {
          page,
          category: this.currentCategoryId,
          dimension: size,
          sort: sortBy[sort],
        })
        .then(({ data: { total, entries } }) => {
          this.products = entries
          this.productPages = Math.ceil(total / 16)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  },
}

const sortBy = {
  relevanz: '',
  teuerste: 'expensive',
  neueste: 'new',
  aelteste: 'old',
  guenstigste: 'cheap',
}
